import { ReactElement } from 'react';
import { OnlineThemeType } from '../../themes/online';

export interface ICardProps {
  className?: string;
  breakingSizeQuery?: string;
  isDisabled?: boolean;
  isSelectable?: boolean;
  isSelected?: boolean;
  isLoading?: boolean;
  isExpandable?: boolean;
  isInitialyExpanded?: boolean;
  expandedContent?: ReactElement;
  loaderContent?: ReactElement;
  handleSelect?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  appearance?: typeof APPEARANCES[keyof typeof APPEARANCES];
}

export const APPEARANCES = {
  REGULAR: 'regular',
  ACCENT: 'accent',
} as const;

export interface ISCardProps extends ICardProps {
  theme: OnlineThemeType;
}
